import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=d2d4e7c2"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=d2d4e7c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports